const loop24 = (n: number) => {
    if (n < 0) return 24 + n;
    if (n > 24) return n - 24;

    return n;
};

export default loop24;
